import { useJobInfo } from "@/api/services/main/job";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { JobDetail } from "@/features/job/components/JobDetail";
import { convertResToFormData } from "@/features/job/utils/convertJobFormData";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";

const JobDetailPage = () => {
  const queryResult = useJobInfo();
  const { data, isLoading } = queryResult;
  useValidateId("jobId", AppRoutes.jobList, queryResult);

  if (!data || isLoading) return <LoadingPage />;
  return <JobDetail defaultValues={convertResToFormData(data.data)} />;
};

export default JobDetailPage;
